<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_3"><b>The Second World War Illustrated</b></a></h1><a id="page_3">
<p class="title1"><i>The Fifth Year</i></p>
<p class="author">J<span class="small">ACK</span> H<span class="small">OLROYD</span></p>
<div class="image_container">
<img alt="images" src="images/f0003-01.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?f8af0c54